import "@pnp/polyfill-ie11"
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueCompositionAPI from '@vue/composition-api'
import '@/assets/styles/tailwind.css'
import "vue-toastification/dist/index.css"
import Toast from "vue-toastification"
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate, {
  rules: {
    ipv4: (ctx: {value: string}) => /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ctx.value),
  },
})

// Vue.use(VueFormulate, {
//   classes: {
//     element: "mt-1",
//     label: "font-medium text-gray-700",
//     help: "text-xs text-gray-500 mt-1",
//     error: "text-xs text-red-500 mt-1",
//     outer: "mb-2",
//     input(context) {
//       switch (context.classification) {
//         case "button":
//           return "px-4 py-2 rounded bg-green-500 text-white hover:bg-green-600";
//         default:
//           return "border border-gray-300 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1";
//       }
//     }
//   }
// });

Vue.use(VueCompositionAPI)
Vue.use(Toast, {timeout: 5000})
Vue.config.productionTip = false

export const vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
